var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgImgSkeletone = function SvgImgSkeletone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 66,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "evenodd",
    d: "M35.119 0H2.267A2.267 2.267 0 000 2.267v61.466A2.267 2.267 0 002.267 66h51.466A2.267 2.267 0 0056 63.733V19.497c-.22-.085-.4-.187-.525-.304L35.119 0z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "lmwdd2bbka",
    width: 56,
    height: 66,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.12 0H2.266A2.267 2.267 0 000 2.267v61.466A2.267 2.267 0 002.267 66h51.466A2.267 2.267 0 0056 63.733V19.497c-.22-.086-.4-.187-.525-.305L35.119 0z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lmwdd2bbka)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillOpacity: 0.12,
    fillRule: "evenodd",
    d: "M48.688 46.78l15.438 20.048H33.251l15.438-20.049z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "uatbdm8wib",
    width: 32,
    height: 21,
    x: 33,
    y: 46,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M48.688 46.78l15.438 20.048H33.251l15.438-20.049z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillOpacity: 0.12,
    fillRule: "evenodd",
    d: "M20.185 28.96l24.937 37.869H-4.753L20.185 28.96z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "5sy6pik20c",
    width: 51,
    height: 39,
    x: -5,
    y: 28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M20.185 28.96l24.937 37.869H-4.753L20.185 28.96z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    fillRule: "evenodd",
    d: "M39.188 35.642c3.28 0 5.938-2.494 5.938-5.57 0-3.075-2.658-5.568-5.938-5.568-3.279 0-5.937 2.493-5.937 5.569 0 3.075 2.658 5.569 5.938 5.569z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M35.625 4.455L52.25 20.048H35.625V4.455z",
    clipRule: "evenodd"
  }))));
};
export default SvgImgSkeletone;